'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _report = require('redux/modules/report');

var reportActions = _interopRequireWildcard(_report);

var _report2 = require('selectors/report');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ProjectReport.scss');

var ProjecReport = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        projectId = _ref.params.projectId;
    return (0, _asyncPromise2.default)(dispatch(reportActions.loadReport({ projectId: projectId })).promise);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    projectType: ownProps.params.type,
    reportData: (0, _report2.getReportData)(state),
    reportLoading: state.report.reportLoading
  };
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ProjecReport, _Component);

  function ProjecReport() {
    (0, _classCallCheck3.default)(this, ProjecReport);
    return (0, _possibleConstructorReturn3.default)(this, (ProjecReport.__proto__ || (0, _getPrototypeOf2.default)(ProjecReport)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjecReport, [{
    key: 'getBackUrl',
    value: function getBackUrl() {
      return '/projects/' + this.props.projectType;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          reportData = _props.reportData,
          reportLoading = _props.reportLoading;
      var project = reportData.project;


      return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Project Report' }),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(_components.BackButton, { asBlock: true, backUrl: this.getBackUrl() }),
          _react2.default.createElement(_components.Loader, { className: 'margin-top-20', show: reportLoading, alignCenter: true }),
          _react2.default.createElement(
            'div',
            { hidden: reportLoading },
            _react2.default.createElement(
              'section',
              { className: styles.section },
              _react2.default.createElement(
                'h3',
                null,
                t('Project'),
                ' "',
                project.fullTitle,
                '"'
              ),
              _react2.default.createElement(_components.ProjectReportInformation, { reportData: reportData })
            ),
            _react2.default.createElement(
              'section',
              { className: styles.section },
              _react2.default.createElement(
                'h3',
                null,
                t('Recipients statistic')
              ),
              _react2.default.createElement(_components.ProjectReportRecipientsStatistic, { reportData: reportData })
            ),
            _react2.default.createElement(
              'section',
              { className: styles.section },
              _react2.default.createElement(
                'h3',
                null,
                t('File info')
              ),
              _react2.default.createElement(_components.ProjectReportFileInfo, { reportData: reportData })
            ),
            _react2.default.createElement(
              'section',
              { className: styles.section },
              _react2.default.createElement(
                'h3',
                null,
                t('Users who played the content')
              ),
              _react2.default.createElement(_components.ProjectReportPlayedUsers, { reportData: reportData })
            ),
            _react2.default.createElement(
              'section',
              { className: styles.section },
              _react2.default.createElement(
                'h3',
                null,
                t('Users who did not access the content')
              ),
              _react2.default.createElement(_components.ProjectReportSkippedUsers, { reportData: reportData })
            )
          )
        )
      );
    }
  }]);
  return ProjecReport;
}(_react.Component), _class2.propTypes = {
  projectType: _propTypes2.default.string,
  reportData: _propTypes2.default.object,
  reportLoading: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  reportData: {}
}, _temp)) || _class) || _class) || _class);
exports.default = ProjecReport;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ProjectReport/ProjectReport.js
// module id = 2204
// module chunks = 1